import React, { useState, useEffect } from 'react';
import { Routes, Route, HashRouter, Switch, useHistory, useNavigate } from "react-router-dom";
import { loaderStateTrue, loaderStateFalse } from '../src/Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from './GlobalModules/Login/Actions/LoginAction';
import { CLEAR_STORES } from './Actions/StoreActions';
import * as Store from './store';
import { initializeNotifications, setupForegroundNotificationListener, initializeAudioOnInteraction } from './GlobalModules/Utility/Firebase';
import { connect } from 'react-redux';
import Popup from 'react-popup';
import 'dotenv/config'
import log from 'loglevel';
import LoginIndex from './GlobalModules/Login/Routes/LoginIndex'
import MfaRoutes from './GlobalModules/Routes/MfaRoutes';
import GlobalRoutes from './GlobalModules/Routes/GlobalRoute';
import logger from './logger';
import { withNamespaces } from 'react-i18next';
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
import Default from "../src/Layout/Default";
import LoginUtility from '../src/GlobalModules/Utility/Utility';
import ErrorBoundary from '../src/GlobalModules/Utility/Components/ErrorBoundary';
import ModalGlobal from '../src/GlobalModules/Utility/Components/ModalGlobal';
import SmsVerification from './GlobalModules/Login/Components/SmsVerification';
import { getCurrentUser, verifySoftwareToken, mfaAssign } from './GlobalModules/Login/Controller/LoginController';
import EventEmitter from '../src/GlobalModules/Utility/Components/EventEmitter';
import PublicRestaurantMenu from "./V4/Modules/Restaurant/Pages/PublicRestaurantMenu";
import SimpleRestaurantMenu from "./V4/Modules/Restaurant/Pages/SimpleRestaurantMenu";
import TestMenu from "./V4/Modules/Restaurant/Pages/TestMenu";
LoadingOverlay.propTypes = undefined;

const channel = new BroadcastChannel('foobar');

function App(props) {
  const { loaderStateFalse, isLoading, token, userCredentials } = props;
  const [mfaModalFlag, setMfaModalFlag] = useState(false);
  const [live, setLive] = useState(1);

  // useEffect hook to perform side effects based on the 'live' state variable
  // State for notifications
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    if (live === 1) {
      // If so, call the channelMessage function to set up the message listener
      channelMessage();
    }

    // Initialize Firebase notifications when user is logged in
    if (token && token !== "" && Object.keys(props.userCredentials).length > 0 && props.userCredentials.user_details && Object.keys(props.userCredentials.user_details).length > 0) {
      // console.log('token', token)
      initializeNotifications();
      const unsubscribe = setupForegroundNotificationListener(setNotification);

      // Set up event listeners to initialize audio on user interaction
      const initAudio = () => {
        // Try to initialize audio (function returns boolean, not a promise)
        const success = initializeAudioOnInteraction();
        if (success) {
          // If successful, we can remove the event listeners
          document.removeEventListener('click', initAudio);
          document.removeEventListener('touchstart', initAudio);
        }
      };

      // Add event listeners for user interaction
      document.addEventListener('click', initAudio);
      document.addEventListener('touchstart', initAudio);

      // Clean up listener when component unmounts
      return () => {
        if (unsubscribe && typeof unsubscribe === 'function') {
          unsubscribe();
        }
        // Remove event listeners
        document.removeEventListener('click', initAudio);
        document.removeEventListener('touchstart', initAudio);
      };
    }
  }, [live, token, props.userCredentials]);

  // Function to set up the message listener on the channel
  const channelMessage = () => {
    // Assign a callback function to handle incoming messages from the channel
    channel.onmessage = (event) => {
      if (event.data.isLogout) {
        const { setToken, setUserCredentials } = props;
        localStorage.setItem("selectedTabName", "")
        setToken("", "", "", "", [], [], '').then((res) => {
          setUserCredentials({});
        })
        Store.default.dispatch({
          type: CLEAR_STORES
        });
        // window.location.href = window.location.origin + "/";
      }
    };
    loaderStateFalse();
  }

  //after fetch user details check user is mandatory mfa or not
  useEffect(() => {
    // console.log('userCredentials', props.userCredentials);
    if (Object.keys(props.userCredentials).length > 0 && props.userCredentials.user_details && Object.keys(props.userCredentials.user_details).length > 0 && props.userCredentials.user_details.hasOwnProperty('mfa') && props.userCredentials.user_details.mfa == null && props.userCredentials.user_details.user_type !== 'app_admin') {
      if (props.userGroup && props.userGroup.length > 0) {
        //check from all organisation , mfa is mandatory or not
        let userMfaEnableFlag = props.userGroup.some(user => user.is_mfa_required === true);
        if (userMfaEnableFlag) {
          setMfaModalFlag(true)
        } else {
          setMfaModalFlag(false)
        }
      }
    } else {

    }
  }, [props.userCredentials])

  //close mfa modal fn
  const closeMfaModalFn = () => {
    setMfaModalFlag(false)
  }

  //mfa otp submit fn callback
  const handleSubmitOtpVerfication = (otp, type) => {
    const { loaderStateTrue, loaderStateFalse } = props;
    if (type === 'authenticator') {
      loaderStateTrue();
      let data = {
        "mfaCode": otp.join(''),
      }
      verifySoftwareToken(data).then((response) => {
        if (response.success) {
          const mfaAssignData = {
            "mfa_type": "authenticator_app",
            "user_name": props.userCredentials?.user_details?.user_email != "" && props.userCredentials?.user_details?.user_email != null ? props.userCredentials?.user_details?.user_email : props.userCredentials?.user_details?.contact_number
          }
          mfaAssign(mfaAssignData).then((response) => {
            if (response.success) {
              setMfaModalFlag(false);
              getCurrentUserFn();
            } else {
              LoginUtility.toastNotifications(response.message, 'Error', 'error');
            }
            loaderStateFalse();
          }).catch((error) => {
            loaderStateFalse();
          });
        } else {
          LoginUtility.toastNotifications(response.message, "Error", "error")
        }
        loaderStateFalse();
      }).catch((error) => {
        console.error("************error*************", error)
        if (error) {
          LoginUtility.toastNotifications(error?.response?.message, "Warning", "warning")
        }
        loaderStateFalse();
      });
    }
  }

  //fetch current user data
  const getCurrentUserFn = () => {
    const { loaderStateTrue, loaderStateFalse, setUserCredentials, loginCredentials } = props;
    getCurrentUser().then((response) => {
      if (response.success) {
        setUserCredentials(response.data);
        //for routing , emit the data to mfa page 
        EventEmitter.emit("sendMessage", "route_permission")
      }
    }).catch((error) => {
      console.error("************error*************", error)
      loaderStateFalse();
    });
  }

  function Loading() {
    return (
      <>
        <div className="wrapperContainer">
          <span>Loading</span>
        </div>
      </>
    );
  }


  //  console.log('1--------', props.userCredentials , token)
  //  console.log('2--------',props.userCredentials?.user_details?.version === 'v4' && token !== "" && props.mfa == null && props.userGroup.some(user => user.is_mfa_required === true))
  return (
    <>
      <LoadingOverlay
        active={isLoading}
        className='lodingOverlayDivContainer'
        spinner={<FadeLoader color={'#ccc !important'} size={50} margin='0px' speedMultiplier={0.3} />}
        styles={{
          overlay: (base) => ({
            ...base,
            background: 'rgba(255, 255, 255, 0.1)',
            zIndex: '9999999999999'
          })
        }}
      >
        <Popup />
        <HashRouter>
          <Switch>
            {/* Public routes - accessible without authentication */}
            <Route path="/:lng/test_menu" component={TestMenu} />
            <Route path="/:lng/our_menu/:menuSlug" component={SimpleRestaurantMenu} />
            <Route path="/:lng/full_menu/:menuSlug" component={PublicRestaurantMenu} />

            {/* Protected routes - require authentication */}
            <Route path="*" render={() => (
              Object.keys(props.userCredentials).length > 0 && token !== "" && (!props.userCredentials?.user_details?.version || props.userCredentials?.user_details?.version === '') ? (
                <GlobalRoutes />
              ) :
                (
                  <>
                    {props.userCredentials?.user_details?.version === 'v4' && token !== "" && props.mfa == null && props.userGroup.some(user => user.is_mfa_required === true) ? (
                      <MfaRoutes />
                    )
                      : props.userCredentials?.user_details?.version === 'v4' && token !== "" ? (
                        <GlobalRoutes />
                      )
                        : (
                          <LoginIndex />
                        )

                    }

                  </>
                )
            )} />
          </Switch>
          {/* mfa modal */}
          <ErrorBoundary title="ModalGlobal Error">
            <ModalGlobal
              show={mfaModalFlag}
              onHide={closeMfaModalFn}
              title=""
              className="modalcustomizeDialog mondimension smsVerificationModalContent userprofileSmsVerificationModal"
              footer={false}
              headerShow={false}
              closeButton={true}
              saveButtonLabel="Confirm"
              saveButtonClassName="btn btn-primary savebtn"
              cancelShow={true}
              body={
                <>
                  <ErrorBoundary title="GlobalAddEditModalContent Error">
                    <SmsVerification
                      formData={{ 'email': props.userCredentials?.user_details?.user_email }}
                      callFrom={''}
                      handleSubmitOtpVerfication={handleSubmitOtpVerfication}
                      enableMfa={false}
                      closeMfaModalFn={closeMfaModalFn}
                      disableAction={true}
                      landingPage={true}
                    />
                  </ErrorBoundary>
                </>
              }
            />
          </ErrorBoundary>
        </HashRouter>
      </LoadingOverlay >
    </>
  );
}

const mapStateToProps = (globalState) => ({
  isLoading: globalState.mainReducerData.loaderState,
  token: globalState.LoginReducer.token,
  userCredentials: globalState.LoginReducer.userCredentials,
  userGroup: globalState.LoginReducer?.userGroup,
  mfa: globalState?.LoginReducer?.userCredentials?.user_details?.mfa,
});

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setUserCredentials, setToken })(withNamespaces()(App));
